import axios from 'axios';

export default async function validateJwt() {
    try {
        const response = await axios.get('/api/auth/validateJWT', {
            withCredentials: true,
        });
        return {
            valid: true,
            user: response.data.user
        };
    } catch (error) {
        return {
            valid: false,
            reason: (error.response && error.response.data && error.response.data.reason) || 'unauthorized'
        };
    }
}
